import { API_AUTH } from "./common";

const DanhSachTaiSanApi = {
  GetDanhSachTaiSan: ({
    mataisan,
    tentaisan,
    tenkhachhang,
    kho,
    trangthai,
    tinhtrang,
    ghichu,
    pageIndex,
    pageSize,
    loaitaisan = 0,
  }) => {
    // console.log(kho);
    return API_AUTH.get(
      `quan-ly-tai-san/danh-sach-tai-san1?mataisan=${mataisan}&tentaisan=${tentaisan}&tenkhachhang=${tenkhachhang}&kho=${kho}&trangthai=${trangthai}&tinhtrang=${tinhtrang}&ghichu=${ghichu}&pageIndex=${pageIndex}&pageSize=${pageSize}&loaitaisan=${loaitaisan}`,
      {},
    );
  },
  GetDanhSachTaiSanCongTy: ({
    mataisan,
    tentaisan,
    tenkhachhang,
    kho,
    trangthai,
    tinhtrang,
    ghichu,
    pageIndex,
    pageSize,
  }) => {
    // console.log(kho);
    return API_AUTH.get(
      `quan-ly-tai-san/danh-sach-tai-san-cong-ty?mataisan=${mataisan}&tentaisan=${tentaisan}&tenkhachhang=${tenkhachhang}&kho=${kho}&trangthai=${trangthai}&tinhtrang=${tinhtrang}&ghichu=${ghichu}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {},
    );
  },
  addTaiSan: (
    TaiSanID,
    MaTaiSan,
    GhiChu,
    TinhTrangID,
    KhoID,
    LoaiTaiSan,
    TenTaiSan,
    Options,
    ImageList,
  ) => {
    // alert(TenTaiSan);
    //alert(customer.CustomerId);
    return API_AUTH.post("quan-ly-tai-san/them-moi-tai-san", {
      TaiSanID,
      MaTaiSan,
      GhiChu,
      TinhTrangID,
      KhoID,
      LoaiTaiSan,
      TenTaiSan,
      Options,
      ImageList,
    });
  },
  addTaiSanCongTy: (
    TaiSanID,
    MaTaiSan,
    GhiChu,
    TinhTrangID,
    KhoID,
    LoaiTaiSan,
    TenTaiSan,
    Options,
    KhauHao,
    ImageList,
  ) => {
    // alert(TenTaiSan);
    //alert(customer.CustomerId);
    return API_AUTH.post("quan-ly-tai-san/them-moi-tai-san-cong-ty", {
      TaiSanID,
      MaTaiSan,
      GhiChu,
      TinhTrangID,
      KhoID,
      LoaiTaiSan,
      TenTaiSan,
      Options,
      KhauHao,
      ImageList,
    });
  },

  editTaiSan: (
    TaiSanID,
    MaTaiSan,
    GhiChu,
    TinhTrangID,
    KhoID,
    LoaiTaiSan,
    TenTaiSan,
    Options,
    ImageList,
  ) => {
    return API_AUTH.post("quan-ly-tai-san/cap-nhat-tai-san", {
      TaiSanID,
      MaTaiSan,
      GhiChu,
      TinhTrangID,
      KhoID,
      LoaiTaiSan,
      TenTaiSan,
      Options,
      ImageList,
    });
  },
  editTaiSanCongTy: (
    TaiSanID,
    MaTaiSan,
    GhiChu,
    TinhTrangID,
    KhoID,
    LoaiTaiSan,
    TenTaiSan,
    Options,
    KhauHao,
    ImageList,
  ) => {
    return API_AUTH.post("quan-ly-tai-san/cap-nhat-tai-san-cong-ty", {
      TaiSanID,
      MaTaiSan,
      GhiChu,
      TinhTrangID,
      KhoID,
      LoaiTaiSan,
      TenTaiSan,
      Options,
      KhauHao,
      ImageList,
    });
  },
  getOneDetailTaiSan: (taisanId) => {
    //alert(taisanId);
    //alert(customer.CustomerId);
    return API_AUTH.get(`quan-ly-tai-san/chi-tiet?taisanId=${taisanId}`, {});
  },
  getTaiSanCongTy: (taisanId) => {
    //alert(taisanId);
    //alert(customer.CustomerId);
    return API_AUTH.get(`quan-ly-tai-san/chi-tiet2?taisanId=${taisanId}`, {});
  },
  xoaTaiSan: (taisanId) => {
    // console.log(taisanId);
    // alert(taisanId);
    //alert(customer.CustomerId);
    return API_AUTH.post(
      `quan-ly-tai-san/xoa-tai-san?taisanId=${taisanId}`,
      {},
    );
  },
  chuyenKho: (taisanId, ngayChuyenKho, khoChuyenDenId, ghichu) => {
    // alert(TenTaiSan);
    //alert(customer.CustomerId);
    return API_AUTH.post(
      `quan-ly-tai-san/chuyen-kho?taisanId=${taisanId}&ngayChuyenKho=${ngayChuyenKho}&khoChuyenDenId=${khoChuyenDenId}&ghichu=${ghichu} `,
      {
        taisanId,
        ngayChuyenKho,
        khoChuyenDenId,
        ghichu,
      },
    );
  },
  addChoThue: (
    DuongDanAnh,
    HoTen,
    SoDienThoai,
    DiaChi,
    CMND,
    NgayMuon,
    NgayTra,
    NguoiTao,
    KhachHang_GhiChu,
    TaiSanId,
    PhiThue,
    TaiSan_GhiChu,
  ) => {
    return API_AUTH.post("quan-ly-tai-san/them-moi-cho-thue", {
      DuongDanAnh,
      HoTen,
      SoDienThoai,
      DiaChi,
      CMND,
      NgayMuon,
      NgayTra,
      NguoiTao,
      KhachHang_GhiChu,
      TaiSanId,
      PhiThue,
      TaiSan_GhiChu,
    });
  },

  soHuu: (taiSanId) => {
    return API_AUTH.post(`quan-ly-tai-san/so-huu?taiSanId=${taiSanId}`, {});
  },

  giaHan: (TaiSanID, GiaHanDenNgay, LyDo, GhiChu) => {
    return API_AUTH.post("quan-ly-tai-san/gia-han", {
      TaiSanID,
      GiaHanDenNgay,
      LyDo,
      GhiChu,
    });
  },

  getLichSuGiaHan: (taiSanId, pageSize, pageIndex) => {
    return API_AUTH.post(
      `quan-ly-tai-san/lich-su-gia-han?taiSanId=${taiSanId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {
        taiSanId,
        pageSize,
        pageIndex,
      },
    );
  },

  thanhLy: (
    TaiSanID,
    KhachHang_Id,
    TenKhachHang,
    NgayThanhLy,
    GhiChu,
    TienThanhLy,
    TienKhachTra,
    PhiKhac,
  ) => {
    return API_AUTH.post(`quan-ly-tai-san/thanh-ly`, {
      TaiSanID,
      KhachHang_Id,
      TenKhachHang,
      NgayThanhLy,
      GhiChu,
      TienThanhLy,
      TienKhachTra,
      PhiKhac,
    });
  },

  thuHoi: (
    TaiSanID,
    NgayTao,
    NguoiTao,
    PhiThuHoi,
    NguoiNop,
    NguoiGiaoDich,
    KhoNhap,
    LyDo,
  ) => {
    return API_AUTH.post(`quan-ly-tai-san/thu-hoi`, {
      TaiSanID,
      NgayTao,
      NguoiTao,
      PhiThuHoi,
      NguoiNop,
      NguoiGiaoDich,
      KhoNhap,
      LyDo,
    });
  },
  phiThuTaiSan: (taisanId) => {
    return API_AUTH.get(
      `quan-ly-tai-san/phi-thu-cho-muon-tai-san?taisanId=${taisanId}`,
      {},
    );
  },
};

export default DanhSachTaiSanApi;
